export default "__VITE_ASSET__CymB2eQ8__"